import UserDetailView from './UserDetailView';
import UserClusteringAnalysisComparator from './UserClusteringAnalysisComparator';
import UserClusteringAnalysis from './UserClusteringAnalysis';
import UserTable from './UserTable'
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import { Breadcrumb, Row, Col, DatePicker, Button, Pagination, Space, Progress, Modal, Divider, Cascader, Radio } from 'antd';
import { RedoOutlined, LoadingOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import React from 'react';


// import the core library.
//import ReactEchartsCore from 'echarts-for-react/lib/core';
import ReactEcharts from 'echarts-for-react';

// then import echarts modules those you have used manually.
//import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
//import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/scatter';
// import 'echarts/lib/chart/radar';

// import 'echarts/lib/chart/map';
// import 'echarts/lib/chart/treemap';
// import 'echarts/lib/chart/graph';
// import 'echarts/lib/chart/gauge';
// import 'echarts/lib/chart/funnel';
// import 'echarts/lib/chart/parallel';
// import 'echarts/lib/chart/sankey';
// import 'echarts/lib/chart/boxplot';
// import 'echarts/lib/chart/candlestick';
// import 'echarts/lib/chart/effectScatter';
// import 'echarts/lib/chart/lines';
// import 'echarts/lib/chart/heatmap';

// import 'echarts/lib/component/graphic';
// import 'echarts/lib/component/grid';
// import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/polar';
// import 'echarts/lib/component/geo';
// import 'echarts/lib/component/parallel';
// import 'echarts/lib/component/singleAxis';
// import 'echarts/lib/component/brush';

import 'echarts/lib/component/title';

// import 'echarts/lib/component/dataZoom';
// import 'echarts/lib/component/visualMap';

// import 'echarts/lib/component/markPoint';
// import 'echarts/lib/component/markLine';
// import 'echarts/lib/component/markArea';

// import 'echarts/lib/component/timeline';
// import 'echarts/lib/component/toolbox';

// import 'zrender/lib/vml/vml';

// The usage of ReactEchartsCore are same with above.

class UserClusteringForm extends React.Component {
    fileTypeOptions = [
        {
            label: 'CSV',
            value: 'CSV'
        }, {
            label: 'Excel',
            value: 'EXCEL'
        }, {
            label: '文本(\\u000e分隔)',
            value: 'TEXT'
        }
    ];

    wxOpenIdOptions = [
        {
            label: '薄荷',
            value: 'mint'
        }, {
            label: '芝士派',
            value: 'cya'
        }, {
            label: '蛋糕训练营',
            value: 'cake_pap'
        }, {
            label: '蛋糕年课',
            value: 'cake_ralph'
        }, {
            label: '蛋糕App',
            value: 'cake_hodor'
        }, {
            label: '夜曲',
            value: 'nocturne'
        }, {
            label: '柚子鸭',
            value: 'kids'
        }, {
            label: '不导出',
            value: ''
        }
    ];

    constructor() {
        super();
        this.state = {
            currentView: 'Form',
            bczUid: 0,
            users: [],
            totalCountOfUsers: 0,
            dateRange: [moment(), moment()],
            summary: {},
            pageSize: 10,
            pageNo: 1,
            clusterDailySize: [],
            exportingTask: {},
            exportingModal: {}
        };
    }

    async componentDidMount() {
        const summary = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/summary`);
        const dateRange = [moment(summary.eldestDate), moment(summary.latestDate)];
        if (summary) {
            summary.id = this.props.clusteringId;
        }
        this.setState({ summary: summary, dateRange: dateRange });
        this.fetchClusterSizeRecords(dateRange);
        this.fetchClusterUsers(this.state.pageNo, this.state.pageSize);

        const exportingTask = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/users/export`);
        this.setState({ exportingTask });

        if (exportingTask.state === 'INIT' || exportingTask.state === 'RUNNING') {
            this.pollExportTask();
        }

        auth.appendLog('ClusteringForm', { clusteringId: this.props.clusteringId });
    }

    render() {
        const navigator = (title) => <Breadcrumb>
            <Breadcrumb.Item>用户分群</Breadcrumb.Item>
            <Breadcrumb.Item>
                <Button type="link" size="small" onClick={() => this.props.onBackward()}>分群列表</Button>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to={'/form'}>人群洞察</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                {title}
            </Breadcrumb.Item>
        </Breadcrumb>;

        return <Router basename={`/user_profile/clustering/${this.props.clusteringId}`} >
            <Switch>
                <Route path="/form" exact render={() => this.renderForm()} />
                <Route path="/users/:id" exact render={(history) =>
                    <UserDetailView navigator={navigator('')} bczUid={history.match.params.id} />
                } />
                <Route path="/vs/:id" exact render={(history) =>
                    <UserClusteringAnalysisComparator navigator={navigator('')}
                        leftSummary={this.state.summary}
                        leftId={this.props.clusteringId}
                        rightId={history.match.params.id} />
                } />
                <Route path="/analysis" exact render={() =>
                    <UserClusteringAnalysis
                        navigator={navigator('')}
                        clustering={this.state.summary}
                        clusteringId={this.props.clusteringId}
                    />
                } />
            </Switch>
        </Router>
    }

    renderForm() {
        return <>
            {this.state.exportingModal.visible && <Modal
                title={"分群用户导出"}
                visible={this.state.exportingModal.visible}
                onOk={() => {
                    this.beginExportClusteringUsers();
                    const state = this.state.exportingModal;
                    state.visible = false;
                    this.setState({ exportingModal: state });
                }}
                onCancel={() => {
                    const state = this.state.exportingModal;
                    state.visible = false;
                    this.setState({ exportingModal: state });
                }}>
                <Row>
                    <span>导出完成后会发送企业微信通知，最多导出10万行数据。</span>
                </Row>
                <Divider />
                <Row>
                    <Col span={5} style={{ alignSelf: 'center' }}>
                        <span>文件类型：</span>
                    </Col>
                    <Col>
                        <Radio.Group
                            options={this.fileTypeOptions}
                            onChange={(value) => {
                                const state = this.state.exportingModal;
                                state.fileType = value.target.value;
                                this.setState({ exportingModal: state });
                            }}
                            value={this.state.exportingModal.fileType}
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col span={5} style={{ alignSelf: 'center' }}>
                        <span>微信OpenId：</span>
                    </Col>
                    <Col style={{ alignSelf: 'center' }}>
                        <Radio.Group
                            options={this.wxOpenIdOptions}
                            onChange={(value) => {
                                const state = this.state.exportingModal;
                                state.openIdKey = value.target.value;
                                this.setState({ exportingModal: state });
                            }}
                            value={this.state.exportingModal.openIdKey}
                        />
                    </Col>
                </Row>
                <Divider />
                <Row>
                    <Col><span>导出的列：</span></Col>
                    <Col flex="auto"></Col>
                    <Col flex="50%">
                        <Cascader
                            options={this.state.exportingModal.allTags}
                            onChange={(value) => {
                                const state = this.state.exportingModal;
                                const uniqueIds = new Set(state.exportingTags);
                                uniqueIds.add(parseInt(value[1]));
                                state.exportingTags = [];
                                for (let id of uniqueIds.values()) {
                                    state.exportingTags.push(id);
                                }
                                this.setState({ exportingModal: state });
                            }}
                            placeholder="选择需要导出的列"
                            style={{ width: '100%' }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={2}>[1]</Col>
                    <Col>集团基础属性 / 百词斩用户ID</Col>
                </Row>
                {this.state.exportingModal.exportingTags.map((tagId, index) =>
                    <Row>
                        <Col span={2}>[{index + 2}]</Col>
                        <Col>{this.mappedTags[tagId.toString()]}</Col>
                        <Col><Button type="link" size="small" onClick={() => {
                            const state = this.state.exportingModal;
                            const tags = [];
                            for (let item of state.exportingTags) {
                                if (item !== tagId) {
                                    tags.push(item);
                                }
                            }
                            state.exportingTags = tags;
                            this.setState({ exportingModal: state });
                        }}>[删除]</Button></Col>
                    </Row>
                )}
                {this.state.exportingModal.openIdKey !== '' && <>
                    <Row>
                        <Col span={2}>[{this.state.exportingModal.exportingTags.length + 2}]</Col>
                        <Col>open_id</Col>
                    </Row>
                    <Row>
                        <Col span={2}>[{this.state.exportingModal.exportingTags.length + 3}]</Col>
                        <Col>union_ids</Col>
                    </Row>
                </>}
            </Modal>}
            <Row>
                <Breadcrumb>
                    <Breadcrumb.Item>用户分群</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Button type="link" size="small" onClick={() => this.props.onBackward()}>分群列表</Button>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>分群预览</Breadcrumb.Item>
                </Breadcrumb>
            </Row>
            <div style={{ height: '20px' }} />
            <Row>
                <Col>
                    <h2>{this.state.summary.name}</h2>
                </Col>
            </Row>
            <Row>
                <Col span={4} style={{ alignSelf: 'center' }}>
                    <span>最新更新时间：{this.state.summary.latestDate}</span>
                </Col>
                <Col span={2}>
                    <Button
                        type="primary"
                        icon={<RedoOutlined />}
                        onClick={() => window.location = `/user_profile/clustering/${this.props.clusteringId}/analysis`} >
                        用户画像分析
                    </Button>
                </Col>
                {this.renderExportingTask()}
                <Col flex="auto" />
                <Col span={5}>
                    <DatePicker.RangePicker
                        style={{ width: '90%' }}
                        locale={locale}
                        value={this.state.dateRange}
                        onChange={this.clusteringSizeDateRangeDidChanged}
                    />
                </Col>
            </Row>
            <div style={{ height: '20px' }} />
            <Row>
                <Col span={24}>
                    <ReactEcharts option={this.getClusteringSizeOptions()} />
                </Col>
            </Row>
            <div style={{ height: '20px' }} />
            <Row>
                <Col>
                    <h1>用户列表</h1>
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <UserTable
                        dataSource={this.state.users}
                        onShowDetail={(bczUid) => window.location = `/user_profile/clustering/${this.props.clusteringId}/users/${bczUid}`}
                    />
                </Col>
            </Row>
            <div style={{ height: '30px' }} />
            <Row>
                <Col span={4}>
                    <span style={{ color: 'gray' }}>
                        共 {this.state.totalCountOfUsers} 条记录 第 {this.state.pageNo} / {this.getMaxPage()} 页
                    </span>
                </Col>
                <Col flex="auto" />
                <Col>
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        defaultCurrent={1}
                        total={this.state.totalCountOfUsers}
                        current={this.state.pageNo}
                        pageSize={this.state.pageSize}
                        onChange={this.clusterUsersPageNoDidChanged}
                        onShowSizeChange={this.clusterUsersPageSizeDidChanged} />
                </Col>
            </Row>
            <div style={{ height: '20px' }} />
        </>
    }

    renderExportingTask() {
        switch (this.state.exportingTask.state) {
            case 'NONE':
                return <Col offset={1} style={{ alignSelf: 'center' }}>
                    <Button onClick={() => this.showExportClusteringUsersModal()}>导出用户列表</Button>
                </Col>
            case 'INIT':
                return <Col offset={1} style={{ alignSelf: 'center' }}>
                    <Space>
                        <LoadingOutlined />
                        <span>准备导出...</span>
                    </Space>
                </Col>
            case 'RUNNING': {
                const progressedRows = this.state.exportingTask.progressedRows;
                const totalRows = this.state.exportingTask.totalRows;
                return <Col offset={1} style={{ alignSelf: 'center' }}>
                    <Space>
                        <span>导出中...</span>
                        <Progress style={{ width: 170 }} percent={(progressedRows / totalRows * 100).toFixed(0)} size="small" />
                    </Space>
                </Col>
            }
            case 'OK':
                return <Col offset={1} style={{ alignSelf: 'center' }}>
                    <Space>
                        <span>下载用户列表：</span>
                        <a href={this.state.exportingTask.downloadUrl}>[{this.state.exportingTask.updatedAt}]</a>
                        <Button onClick={() => this.showExportClusteringUsersModal()}>重新导出</Button>
                    </Space>
                </Col>
            case 'FAIL':
                return <Col offset={1} style={{ alignSelf: 'center' }}>
                    <Space>
                        <span style={{color: 'red'}}>导出任务失败！</span>
                        <Button onClick={() => this.showExportClusteringUsersModal()}>重新导出</Button>
                    </Space>
                </Col>;
            default:
                break;
        }
    }

    getClusteringSizeOptions() {
        return {
            title: {
                text: '用户规模变化'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: this.state.clusterDailySize.map(item => item.date)
                }
            ],
            yAxis: [
                {
                    type: 'value',
                }
            ],
            series: [
                {
                    name: '人群数量',
                    type: 'bar',
                    barWidth: '60%',
                    itemStyle: {
                        color: '#038BFF'
                    },
                    data: this.state.clusterDailySize.map(item => item.result)
                }
            ]
        };
    }

    getMaxPage() {
        if (!this.state.pageSize) {
            return 0;
        }
        return Math.trunc((this.state.totalCountOfUsers + this.state.pageSize - 1) / this.state.pageSize);
    }

    clusteringSizeDateRangeDidChanged = (date) => {
        this.setState({ dateRange: date });
        this.fetchClusterSizeRecords(date);
    }

    clusterUsersPageNoDidChanged = (pageNo) => {
        if (pageNo !== this.state.pageNo) {
            this.setState({ pageNo: pageNo });
            this.fetchClusterUsers(pageNo, this.state.pageSize);
        }
    }

    clusterUsersPageSizeDidChanged = (pageNo, pageSize) => {
        //console.log(`on pageSize ${pageNo} ${pageSize}`);
        this.setState({ pageNo: pageNo, pageSize: pageSize });
        this.fetchClusterUsers(pageNo, pageSize);
    }

    async fetchClusterSizeRecords(dateRange) {
        const beginDate = dateRange[0].format('YYYY-MM-DD');
        const endDate = dateRange[1].format('YYYY-MM-DD');
        const sql = `/api/v1/user_clustering/clusters/${this.props.clusteringId}/size?beginDate=${beginDate}&endDate=${endDate}`;
        const data = await UIFetchService.get(sql);
        this.setState({ clusterDailySize: data });
    }

    async fetchClusterUsers(pageNo, pageSize) {
        let url = `/api/v1/user_clustering/clusters/${this.props.clusteringId}/users?pageNo=${pageNo}&pageSize=${pageSize}`;
        const page = await UIFetchService.get(url);
        this.setState({ users: page.items, totalCountOfUsers: page.total });
    }

    // "/clusters/{id}/users/export/tags"
    async showExportClusteringUsersModal() {
        const mappedTags = {};
        const tags = await UIFetchService.get('/api/v1/metadata/tags/tree?filter=analysis');
        const tagsOptions = tags.map(category => {
            return {
                label: category.title,
                value: category.key,
                children: category.children.map(tag => {
                    mappedTags[tag.key] = `${category.title} / ${tag.title}`
                    return {
                        label: tag.title,
                        value: tag.key
                    };
                })
            };
        });

        const options = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/users/export/default`);
        const modal = this.state.exportingModal;
        modal.visible = true;
        modal.allTags = tagsOptions;
        modal.exportingTags = options.tags;
        modal.openIdKey = options.openIdKey;
        modal.fileType = options.fileType;
        this.mappedTags = mappedTags;
        this.setState({ exportingModal: modal });
    }

    async beginExportClusteringUsers() {
        const exportingTask = await UIFetchService.post(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/users/export`,
            {
                fileType: this.state.exportingModal.fileType,
                tags: this.state.exportingModal.exportingTags,
                openIdKey: this.state.exportingModal.openIdKey
            });
        this.setState({ exportingTask });

        this.pollExportTask();
    }

    pollExportTask() {
        this.timer = setInterval(async () => {
            const current = await UIFetchService.get(`/api/v1/user_clustering/clusters/${this.props.clusteringId}/users/export`);
            if (current.state === 'OK' || current.state === 'FAIL') {
                clearInterval(this.timer);
            }
            this.setState({ exportingTask: current });
        }, 3000);
    }
}

export default UserClusteringForm;